export default "__VITE_ASSET__DtfchGna__"